var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160789",
    "data-name": "Group 160789",
    transform: "translate(-304 -465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160783",
    "data-name": "Group 160783",
    transform: "translate(11 84)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(293 381)",
    fill: "#ff5100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160788",
    "data-name": "Group 160788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chatbox-outline",
    d: "M55.6,64H49.182A1.189,1.189,0,0,0,48,65.19v4.078a1.189,1.189,0,0,0,1.182,1.19h.844v1.7L52,70.5a.168.168,0,0,1,.108-.04H55.6a1.189,1.189,0,0,0,1.182-1.19V65.19A1.189,1.189,0,0,0,55.6,64Z",
    transform: "translate(260.5 406.5)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    transform: "translate(310 473)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_248",
    "data-name": "Ellipse 248",
    transform: "translate(312.35 473)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    transform: "translate(314.7 473)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.65,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.65,
    cy: 0.65,
    r: 0.15,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatIcon);
export default __webpack_public_path__ + "static/media/live-chat-icon.8ddb928c071f0765810459a7e4e43c11.svg";
export { ForwardRef as ReactComponent };